// in config.js
import { createChatBotMessage } from "react-chatbot-kit";
import Gaurav from "./GauravPicture";

const botName = "Bot Alpha";

const config = {
  initialMessages: [createChatBotMessage(`Hi! I'm ${botName}`)],
  botName: botName,
  customStyles: {
    botMessageBox: {
      backgroundColor: "#376B7E",
    },
    chatButton: {
      backgroundColor: "#5ccc9d",
    },
  },
  widgets: [
        {
            widgetName: 'Gaurav',
            widgetFunc: (props) => <Gaurav {...props} />,
        }
  ],

  customComponents: {
     // Replaces the default header
    // header: () => <div style={{ padding: "5px", borderRadius: "3px" }}>This is the header</div>,

    // botAvatar: (props) => <MyAvatar {...props} />,

    // // Replaces the default bot chat message container
    // botChatMessage: (props) => <MyCustomChatMessage {...props} />,

    // // Replaces the default user icon
    // userAvatar: (props) => <MyCustomAvatar {...props} />,
    
    // // Replaces the default user chat message
    // userChatMessage: (props) => <MyCustomUserChatMessage {...props} />
  },
};

export default config;
